"use client";
import { useTrial } from "@/context/TrialContext";
import { useLanguage } from "@/context/LanguageContext";
import styles from "./TrialBanner.module.scss";

export default function TrialBanner() {
  const { isTrial, isTrialExpired, daysRemaining } = useTrial();
  const { t } = useLanguage();

  if (!isTrial) return null;

  const message = isTrialExpired
    ? t("trial.expiredBanner")
    : t("trial.activeBanner")
        .replace("{days}", String(daysRemaining))
        .replace("{plural}", daysRemaining !== 1 ? "s" : "");

  return (
    <div className={`${styles.banner} ${isTrialExpired ? styles.expired : styles.active}`}>
      <span className={styles.icon}>{isTrialExpired ? "🔒" : "⏳"}</span>
      <span className={styles.message}>{message}</span>
    </div>
  );
}
